<template lang="pug">
  header
    .sticky-mobile-bar(:class="stickyHeaderClass")
      button.hamburger.hamburger--3dy(
        type="button"
        :class="{ 'is-active': sidebar }"
        @click="toggleSidebar"
      )
        span.hamburger-box
          span.hamburger-inner
      ShoppingCart
    .top-header
      ul.select-language
        li(v-if="baseUrl != '127.0.0.1:9006'")
          a(href="https://isserstedt-pruefservice.de" target="_self" rel="noopener")
            img(src="@/assets/flag_de.png" rel="noopener" alt="Deutsch" title="Deutsch")
        li(v-if="!baseUrl != 'en.isserstedt-pruefservice.de'")
          a(href="https://en.isserstedt-pruefservice.de" target="_self" rel="noopener")
            img(src="@/assets/flag_en.png" rel="noopener" alt="English" title="English")
        li(v-if="!baseUrl != 'nl.isserstedt-pruefservice.de'")
          a(href="https://nl.isserstedt-pruefservice.de" target="_self" rel="noopener")
            img(src="@/assets/flag_nl.png" rel="noopener" alt="Nederlands" title="Nederlands")
      Menu#header-menu(k="header-menu", :max-depth="1")
    .container.mx-auto.z-50
      .logo(v-if="isHomepage")
          img(v-if="logo && logo.id", :src="image.src", title="logo", rel="noopener")
          img(v-else src="@/assets/logo.png")
      .logo(v-else)
          router-link(:to="{ path: '/'}")
            img(v-if="logo && logo.id", :src="image.src", title="logo", rel="noopener")
            img(v-else src="@/assets/logo.png")
      Menu#main-menu(k="main-menu", :max-depth="3")
    //- .desktop-navbar
    //-   .logo-wrapper
    //-     img#logo(v-if="logo && logo.id" :src="image.src" title="logo" rel="noopener")
    //-     img#logo(v-else src="@/assets/logo.png")
    //-   .main-menu-wrapper
    //-     Menu#header-menu(k="header-menu" :max-depth="1")
    //-     //- nav#main-menu
    //-     //-   TreeMenu(:items="items" :max-depth="2" :delay="400")
    //-     //- a.search.icon.is-large(href="#" @click.prevent="openSearch")
    //-     //-   font-awesome-icon(icon="search")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import { trim } from '@/helpers';

import Menu from '@/components/Menu.vue';
import ShoppingCart from '@/extensions/shop/components/ShoppingCart.vue';

export default {
  name: 'Header',
  data: () => ({
    lastScroll: 0,
    stickyHeaderClass: ''
  }),
  components: {
    Menu,
    ShoppingCart
  },
  computed: {
    baseUrl() {
      return window.location.host
    },
    isHomepage() {
      if (this.$route.path == '/') {
        return true;
      } else {
        return false;
      }
    },

    image() {
      const storageRoute = trim(
        `${process.env.VUE_APP_API_HTTP}${process.env.VUE_APP_API_ENDPOINT}${process.env.VUE_APP_API_PUBLIC_STORAGE_ROUTE}`,
        '/'
      );

      const fit = 'fit=fill&w=350&h=150';

      let width = this.logo.width;
      let height = this.logo.height;

      return {
        src: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}`,
        error: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=greyscale`,
        loading: `${storageRoute}/images/${this.logo.id}/${this.logo.name}?${fit}&preview=blur`,
        width,
        height
      };
    },
    ...mapGetters({
      logo: 'logo',
      menus: 'menus',
      sidebar: 'sidebar'
    })
  },
  methods: {
    openSearch() {
      console.log('open search bar');
    },
    toggleSidebar() {
      this.updateSidebarVisibility(!this.sidebar);
    },
    updateStickyHeader() {
      const currentScroll = window.pageYOffset;

      const scrollUp = 'scroll-up';
      const scrollDown = 'scroll-down';

      if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
        this.stickyHeaderClass = scrollDown;
      } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
        this.stickyHeaderClass = scrollUp;
      }

      this.lastScroll = currentScroll;
    },
    ...mapMutations({
      updateSidebarVisibility: 'updateSidebarVisibility'
    })
  },
  mounted() {
    window.addEventListener('scroll', this.updateStickyHeader);
  },
  beforeDestroy() {
    window.removeEventListener('scroll', this.updateStickyHeader);
  }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  display: flex
  background: linear-gradient(90deg, $isserstedt-blue1 0%, $isserstedt-blue2 100%)
  align-items: center
  font-weight: 400
  justify-content: flex-end
  flex-direction: column
  @screen lg
    padding-top: 53px

  @screen lg
    padding-top: 0
  .logo
    @apply float-right
    padding: 1rem
    @screen lg
      @apply float-none
      padding: 1.5rem 1rem
    img
      max-height: 50px
      max-width: 235px
      @screen lg
        max-height: 100px
  .sticky-mobile-bar
    @apply absolute
    top: 46px
    left: 10px
    backdrop-filter: blur(20px)
    transition: transform .15s linear
    z-index: 100
    color: #fff
    @screen md
      left: 98px
    @screen lg
      @apply hidden
    //&.scroll-down
      //transform: translateY(-54px)
    .hamburger
      height: 53px
      padding: 1rem
      .hamburger-inner
        background-color: #fff
        &:before, &:after
          background-color: #fff
    .shopping-cart
      padding: 0 1rem
  .top-header
    @apply flex w-full justify-between items-center
    background-color: $isserstedt-yellow
    .select-language
      @apply pl-4
      li
        @apply inline-block mr-2
        img
          padding-top: 8px
          padding-bottom: 4px
          width: 30px
          height: auto
          @screen lg
            padding-top: 4px
            padding-bottom: 0

    #header-menu
      @apply hidden
      padding: 1rem
      background-color: $isserstedt-yellow
      text-align: right
      @screen lg
        padding: 0.7rem 1rem
        display: block
        z-index: 999
      ::v-deep ul
        & > li
          border: 0
          display: inline-block

          & + li
            // &:before
            //   // content: "/"
            //   content: ""
            //   margin: 0 6px

          &.active .tree-item a
            color: #fff
          .tree-item
            display: inline-block
            a
              transition: all .2s ease-in-out 0s
              line-height: 1
              padding: 0 0.5rem
              color: $isserstedt-blue2
              font-weight: 600
              text-transform: uppercase
              &:hover
                color: #fff

  #main-menu
    @apply hidden
    @screen lg
      display: block

    z-index: 10
    padding: 0 3rem
    &::v-deep
      ul
        display: flex
        justify-content: space-between
        &.tree-menu
          & > li
            transition: background-color .3s ease

            &.active > .tree-item a,
            &.active.visible.hover > .tree-item a
              border-bottom: 4px solid $isserstedt-yellow

            &.visible.hover > .tree-item a
              color: $isserstedt-yellow

            &.visible.hover.has-children
              background: $isserstedt-yellow
              > .tree-item a
                color: #fff

            &:not(.full-width)
              position: relative

            & > .tree-item a
              text-decoration: none
              //text-transform: uppercase
              color: #fff
              padding: 15px 0
              margin: 0 6px
              font-weight: 600
              text-transform: uppercase
              display: flex
              justify-content: space-around
              transition: color .15s ease, border-color .3s ease
              & > .active
                color: #fff
            &.hover
              & > .tree-item a
                border-color: $isserstedt-blue2
                color: #fff
            li
              width: 100%

              &.has-children > .tree-item .down
                float: right
                margin-left: 10px
                margin-top: 5px

              & > .tree-item a
                color: #fff
                background: $isserstedt-yellow
                display: block
                max-width: 500px
                overflow: hidden
                text-overflow: ellipsis
                white-space: nowrap
                padding: 12px 8px
                margin: 0
                &:hover
                  background-color: $isserstedt-blue2
                  color: #fff !important
              &.hover
                & > .tree-item a
                  color: #fff
      & > ul
        &.tree-menu
          & > li
            margin-left: -6px
            margin-right: -6px
            display: inline-block
            & > .tree-item a
              //padding: 15px
              &.router-link-exact-active
                color: $isserstedt-blue2
            &.hover > .tree-item a.router-link-exact-active
              color: $isserstedt-blue2
            & > ul
              &.tree-menu
                position: absolute
                left: 0
                top: 100%
                display: inline-block
                min-width: 200px
                box-shadow: 0 4px 6px -2px rgba(0,0,0,0.3)
                &.full-width
                  width: 100%
                  columns: 3
                  column-gap: 0
                  display: inline-block
                  @screen xl
                    columns: 4
          ul ul
            min-width: 200px
            margin-bottom: 9px
            position: absolute
            display: inline-block
            left: 100%
            top: 0
            box-shadow: 0px 5px 10px 0px rgba(0,0,0,0.3)


      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease
        transform-origin: left center
      .show-enter, .show-leave-to
        opacity: 0
        transform: translateY(6px)

  //- #header-menu,
  //- #main-menu
  //-   @screen lg
  //-     @screen widescreen
  //-       padding-right: 10rem
</style>
